import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b4a5c656&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a5c656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4a5c656')) {
      api.createRecord('b4a5c656', component.options)
    } else {
      api.reload('b4a5c656', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b4a5c656&scoped=true&", function () {
      api.rerender('b4a5c656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z1ziZpc0DrW/JS/comp/Accordion.vue"
export default component.exports